import {
    provideTransloco,
    TranslocoModule,
    TRANSLOCO_LOADER,
} from '@jsverse/transloco';
import { NgModule, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { MfeTranslocoLoader } from './core/mfe/mfe-transloco-loader';
import { IS_MICROFRONTEND, MFE_BASE_URL_TOKEN } from '@client/mfe/tokens/mfe-tokens';
import { MonHttpClientService } from '@monsido/http/http-client.service';
import { environment } from '../environments/environment';

@NgModule({
    exports: [TranslocoModule],
    providers: [
        provideTransloco({
            config: {
                availableLangs: ['en', 'da', 'fr', 'ja', 'nb', 'nl', 'sv', 'es', 'pt'],
                defaultLang: 'en',
                fallbackLang: 'en',
                reRenderOnLangChange: true,
                prodMode: environment.production,
                missingHandler: {
                    logMissingKey: false,
                    useFallbackTranslation: true,
                },
            },
            loader: TranslocoHttpLoader,
        }),
        {
            provide: TRANSLOCO_LOADER,
            useFactory: (
                isMfe: boolean | null,
                http: HttpClient,
                baseUrl: string | null,
                monHttp: MonHttpClientService,
            ) => isMfe && baseUrl
                ? new MfeTranslocoLoader(http, baseUrl)
                : new TranslocoHttpLoader(monHttp),
            deps: [
                [new Optional(), IS_MICROFRONTEND],
                HttpClient,
                [new Optional(), MFE_BASE_URL_TOKEN],
                MonHttpClientService,
            ],
        },
    ],
})
export class TranslocoRootModule {}
